import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import './EmptyState.css';


interface EmptyStateProps {
  icon?: ReactNode;
  title?: string;
  description?: string;
}

function EmptyState({ icon, title, description }: EmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        {icon || (
          <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/>
          </svg>
        )}
      </div>
      <h3 className="empty-state-title">{title || t('errors.emptyTitle')}</h3>
      <p className="empty-state-desc">{description || t('errors.emptyDesc')}</p>
    </div>
  );
}

export default EmptyState;
